import { Badge } from '@risksmart-app/atomic-ui';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { WebhookStatus } from './forms/webhookSchema';
import { isPersistedStatus } from './forms/webhookSchema';

/**
 * Maps a webhook lifecycle status to an atomic-ui Badge variant:
 * active → `success`, paused → `warning`, failed → `destructive`.
 */
const variantFor = (
  status: WebhookStatus
): 'destructive' | 'success' | 'warning' => {
  switch (status) {
    case 'active':
      return 'success';
    case 'paused':
      return 'warning';
    case 'failed':
      return 'destructive';
  }
};

interface Props {
  /** A persisted webhook status; unknown values render as plain text. */
  status: string;
}

/**
 * Coloured badge for a webhook's lifecycle Status in the subscription list.
 */
const WebhookStatusBadge: FC<Props> = ({ status }) => {
  const { t } = useTranslation(['common'], { keyPrefix: 'webhooks.status' });

  if (!isPersistedStatus(status)) {
    return <>{status}</>;
  }

  return <Badge variant={variantFor(status)}>{t(status)}</Badge>;
};

export default WebhookStatusBadge;
